import { Injectable } from '@angular/core';
import { OidcConfiguration } from '../../model/OidcConfiguration';
import { UUIDService } from '../uuid/uuid.service';
import { StorageService } from '../storage/storage.service';
import * as sjcl from 'sjcl';

@Injectable({
  providedIn: 'root'
})
export class NonceService {
  constructor(
    private stotageService: StorageService,
    private uuidService: UUIDService
  ) {}

  public getNonce() {
    return localStorage.getItem(
      this.stotageService.getStorageKey(OidcConfiguration.storageNoncePostfix)
    );
  }

  public setNonce(value) {
    localStorage.setItem(
      this.stotageService.getStorageKey(OidcConfiguration.storageNoncePostfix),
      value
    );
  }

  public hashNonce = function(aNonce) {

   return sjcl.codec.base64.fromBits(sjcl.hash.sha256.hash(aNonce));
  };

  /**
   * GÃ©nÃ¨re et conserve une valeur pour le paramÃ¨tre `nonce`, qui sera vÃ©rifiÃ© par la suite
   */
  public makeNonce() {
    // On rÃ©utilise la valeur actuelle si elle existe (dure le temps d'une sÃ©quence d'autorisation)
    var plainNonce = this.getNonce();
    if (typeof plainNonce == "undefined" || !plainNonce) {
      plainNonce = this.uuidService.uuid();
      // La valeur en clair est conservÃ©e dans le storage
      this.setNonce(plainNonce);
    }
    // Un hash est retournÃ© pour la requÃªte OIDC
    return this.hashNonce(plainNonce);
  }
}

